module.exports = __webpack_public_path__ + "static/Franken1-scaled-6877a641659317c748c5d344dedcef65.jpeg";